import localforage from 'localforage';

/**
 * The active client id for this browser, as every LOS request needs it.
 *
 * ⚠️ READ ONLY. This used to also adopt a `?clientId=` from the URL, which meant the first
 * caller to run happened to decide the tenant — and callers run after authentication has already
 * started issuing requests, so those first requests went out under the PREVIOUS client. Adoption
 * now happens once, before auth, in `Services/clientIdHandoff`; by the time anything calls this,
 * the value in storage is already the right one.
 *
 * Do not reintroduce a write here.
 */
export const getClientId = async (): Promise<string> => {
    try {
        return (await localforage.getItem<string>('clientId')) || '';
    } catch (err) {
        console.error(err);
        return '';
    }
};
